'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
export const NO_RECORD_ERROR = 'NO_RECORD';
export default class ErrorMessage extends Component {
  constructor(...args) {
    super(...args);

    this.renderBody = i18nKey => {
      if (this.props.error === NO_RECORD_ERROR) {
        const href = this.props.signUpLink;
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "login.errors.NO_RECORD.body_jsx",
          options: {
            href
          },
          elements: {
            Link: UILink
          }
        });
      } else {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${i18nKey}.body`
        });
      }
    };
  }

  render() {
    const {
      error,
      fallbackError,
      prefix
    } = this.props;

    if (!error) {
      return /*#__PURE__*/_jsx("div", {});
    }

    let i18nKey = `${prefix}.${error}`;

    if (!I18n.lookup(i18nKey)) {
      i18nKey = `${prefix}.${fallbackError}`;
    }

    return /*#__PURE__*/_jsx(UIAlert, {
      className: "m-bottom-4 text-left",
      "data-error-type": error,
      titleText: I18n.lookup(`${i18nKey}.title`),
      type: "danger",
      children: this.renderBody(i18nKey)
    });
  }

}
ErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
  fallbackError: PropTypes.string,
  prefix: PropTypes.string,
  signUpLink: PropTypes.string
};
ErrorMessage.defaultProps = {
  fallbackError: 'LOGIN_UNAVAILABLE',
  prefix: 'login.errors'
};